import React from 'react';
import { useNavigate } from 'react-router-dom';

const baseStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '60vh',
  fontFamily: 'Inter, system-ui, sans-serif',
  padding: '2rem',
  textAlign: 'center',
};

const headingStyle = {
  fontSize: '1.25rem',
  fontWeight: 600,
  marginBottom: '0.5rem',
  color: '#1F2937',
};

const textStyle = {
  color: '#6B7280',
  marginBottom: '1.5rem',
  maxWidth: '24rem',
};

const btnPrimary = {
  padding: '0.625rem 1.5rem',
  backgroundColor: '#4F46E5',
  color: '#fff',
  border: 'none',
  borderRadius: '0.5rem',
  fontSize: '0.875rem',
  fontWeight: 500,
  cursor: 'pointer',
  marginRight: '0.75rem',
};

const btnSecondary = {
  padding: '0.625rem 1.5rem',
  backgroundColor: '#F3F4F6',
  color: '#374151',
  border: '1px solid #D1D5DB',
  borderRadius: '0.5rem',
  fontSize: '0.875rem',
  fontWeight: 500,
  cursor: 'pointer',
};

export function DesignerErrorFallback({ reset }) {
  const navigate = useNavigate();
  return (
    <div style={baseStyles}>
      <h2 style={headingStyle}>The editor encountered an error</h2>
      <p style={textStyle}>
        Your survey data is safe. You can try again or go back to your surveys.
      </p>
      <div>
        <button onClick={reset} style={btnPrimary}>Try Again</button>
        <button onClick={() => navigate('/workspaces')} style={btnSecondary}>
          Back to Surveys
        </button>
      </div>
    </div>
  );
}

export function ViewerErrorFallback({ reset }) {
  return (
    <div style={baseStyles}>
      <h2 style={headingStyle}>Something went wrong</h2>
      <p style={textStyle}>
        We couldn't load this survey. Please try again in a moment.
      </p>
      <button onClick={reset} style={btnPrimary}>Try Again</button>
    </div>
  );
}

export function AnalyticsErrorFallback({ reset }) {
  const navigate = useNavigate();
  return (
    <div style={baseStyles}>
      <h2 style={headingStyle}>Failed to load analytics</h2>
      <p style={textStyle}>
        There was an error loading the analytics data. Try again or return to your surveys.
      </p>
      <div>
        <button onClick={reset} style={btnPrimary}>Retry</button>
        <button onClick={() => navigate('/workspaces')} style={btnSecondary}>
          Back to Surveys
        </button>
      </div>
    </div>
  );
}
